import { useCallback, useMemo } from "react";

import type { PortfolioProjectFilterValues } from "@/components/ProjectFilter/PortfolioProjectFilterFields";
import {
  getPortfolioProjectFilterQueryParams,
  getPortfolioProjectFiltersFromQueryParams,
  type PortfolioProjectFilterQueryParams,
} from "@/components/ProjectFilter/portfolioProjectFilterQueryParams";
import { useQueryParams } from "@/hooks/useQueryParam";

/** Keeps Portfolio Analytics project filters in the URL. */
export function usePortfolioAnalyticsFilters(): readonly [
  PortfolioProjectFilterValues,
  (newValue: PortfolioProjectFilterValues) => void,
] {
  const [queryParams, setQueryParams] = useQueryParams<PortfolioProjectFilterQueryParams>();
  const filters = useMemo(() => getPortfolioProjectFiltersFromQueryParams(queryParams), [queryParams]);

  const updateFilters = useCallback(
    (newValue: PortfolioProjectFilterValues) => {
      setQueryParams(getPortfolioProjectFilterQueryParams(newValue));
    },
    [setQueryParams],
  );

  return [filters, updateFilters] as const;
}
